<template>
    <a :href="params.data.url" target="_blank">
        {{ params.data.filename }}
    </a>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
});
</script>

<style lang="scss">
</style>
